export var LeaderboardDuration;
(function (LeaderboardDuration) {
    LeaderboardDuration["Day"] = "day";
    LeaderboardDuration["Week"] = "week";
    LeaderboardDuration["Month"] = "month";
})(LeaderboardDuration || (LeaderboardDuration = {}));
export var LeaderboardType;
(function (LeaderboardType) {
    LeaderboardType["PARC"] = "parc";
    LeaderboardType["PART"] = "part";
})(LeaderboardType || (LeaderboardType = {}));
export var LeaderboardRewardType;
(function (LeaderboardRewardType) {
    LeaderboardRewardType["PARC"] = "parc";
    LeaderboardRewardType["PART"] = "part";
    LeaderboardRewardType["ALEO"] = "aleo";
})(LeaderboardRewardType || (LeaderboardRewardType = {}));
export const getLeaderboardRewardAmount = (rank, reward) => {
    return reward.rewards[rank - 1];
};
export const AddressesToExcludeFromLeaderboard = [
    // mainnet parc contract
    'aleo1qkjr490qe7p9v45qrd5pjemmqn4vmgqt8vzc8j0jfwhc7mf5f5zqly7vze',
    // mainnet part contract
    'aleo1rgypwl0h8wgl9q843dj4v8d6naztgz9p3g7fxp8ewdnrucx65grscyjfuf',
    // mainnet spinner v3 contract
    'aleo1zhzvna3ky677m4fw2ywtkujcd5xc9jmftvwc386dn05cdd2c3s8slttkrc',
    // mainnet mystery city contract
    'aleo1xxx4t5elvqzgm5g8x9sgm4e5vfuz560mhrx0h83egjr34jentcgqamhnll',
    // mainnet squash contract
    'aleo13dn2lyphtrn8mujxcqt4vm2rc567k0s3gnnks985p0hhyvfc9yqqy6rdsl',
    // paul old account
    'aleo1mnv3k6qkh5aektf0ptm42jv4v5mn5424wr4crfd4jnqtewxlmvgs549xrj',
    process.env.MAINNET_STORE_OPERATOR_ADDRESS,
    process.env.MAINNET_ARCADE_OPERATOR_ADDRESS,
];
